export class HTTPConfig {
  dataType?: string
  withCredentials?: boolean
  retryAllowed?: boolean
  // contentType: any = 'application/json';
  'X-REP-PLAN-ID': string
  'X-REP-SEARCH-VALUE-PRIVATE': string
  'X-XSRF-TOKEN': string
  'X-REP-TARGET-POID': string
  'X-REP-AVT': string
}
